(function () {
  var slider = document.querySelector('.collection-filter__wrapper');
  if (!slider) return;

  var isDown = false;
  var startX = 0;
  var scrollLeft = 0;
  var speed = Number(slider.dataset.dragSpeed) || 4;

  slider.addEventListener('mousedown', function (event) {
    isDown = true;
    slider.classList.add('active');
    startX = event.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', function () {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mouseup', function () {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mousemove', function (event) {
    if (!isDown) return;
    event.preventDefault();
    var x = event.pageX - slider.offsetLeft;
    var walk = (x - startX) * speed;
    slider.scrollLeft = scrollLeft - walk;
  });
})();
